
import { Vue, Component } from "vue-property-decorator";
import { formatBool, formatDateWithTime } from "../../../utils";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import { PalletResource } from "@/models/api/barcodeSystem/inventory/pallets";
const barcodeOrderModuleState = getModule(InventoryModule);

@Component
export default class PalletHeader extends Vue {
  get currentPallet(): PalletResource {
    return barcodeOrderModuleState.currentPallet;
  }

  get id(): string {
    return barcodeOrderModuleState.currentPallet
      ? barcodeOrderModuleState.currentPallet.id
      : ""; 
  }

  get statusDescription(): string {
    return barcodeOrderModuleState.currentPallet 
      ? barcodeOrderModuleState.currentPallet.statusDescription
      : ""; 
  }

  set statusDescription(val: string){
  }

  get warehouseLocationCode(): string {
    return barcodeOrderModuleState.currentPallet
      ? barcodeOrderModuleState.currentPallet.warehouseLocationCode
      : ""; 
  }

  set warehouseLocationCode(val: string){
  }

  get facilityCode(): string {
    return barcodeOrderModuleState.currentPallet
      ? barcodeOrderModuleState.currentPallet.facilityCode
      : ""; 
  }

  set facilityCode(val: string){
  }

  get isNoScanPallet(): string {
    return barcodeOrderModuleState.currentPallet
      ? formatBool(barcodeOrderModuleState.currentPallet.isNoScanPallet)
      : ""; 
  }

  set isNoScanPallet(val: string){
  }

  get createdDateTimeFormatted(): string {
    return barcodeOrderModuleState.currentPallet
      ? formatDateWithTime(barcodeOrderModuleState.currentPallet.createdDate)
      : "";
  }

  set createdDateTimeFormatted(val: string){
  }
}

